import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { BehaviorSubject } from 'rxjs';
import { Observable } from 'rxjs/internal/Observable';
import { benefitVariants } from 'src/app/model/benefitsVariants';

// const httpOptions = {
// headers: new HttpHeaders({ 'Content-Type': 'application/json' })
// };

@Injectable({
providedIn: 'root'
})

export class QuoteCalcService { 

    public url = './../../../../assets/json/benefitsVariants.json';

    constructor(private http: HttpClient){

    }

    getBenefitsVariants(): any {
        return this.http.get(this.url);
    }
}